/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getCurrentGasDay } from '../../../utils/common/utils';
import { COMMON_MESSAGES } from '../../../constants/Common';
import { get, isRequestCanceled } from '../../../services/GenesisApi';
import { GET_NOMINATION_STATUS } from '../../../constants/Nominations';
import { sendNotification } from '../../../UI/Notification';

interface IDirectLinksStatus {
  nominationStatus: boolean;
  entryCapacityStatus: boolean;
  exitCapacityStatus: boolean;
  tradeMatchingStatus: boolean;
  schedulingStatus: boolean;
}

export interface IDashboardState {
  loadingDirectLinks: boolean;
  directLinkStatusFailed: boolean;
  directLinkStatus: IDirectLinksStatus;
}

export const initialState: IDashboardState = {
  loadingDirectLinks: false,
  directLinkStatusFailed: true,
  directLinkStatus: {
    nominationStatus: true,
    entryCapacityStatus: true,
    exitCapacityStatus: true,
    tradeMatchingStatus: true,
    schedulingStatus: true,
  },
};

export const getNominationStatus = createAsyncThunk('dashboard/getNominationStatus', async () => {
  const gasDay = getCurrentGasDay().format(COMMON_MESSAGES.DATE_YYYY_MM_DD);
  return get(`${GET_NOMINATION_STATUS}?gasDay=${gasDay}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (!isRequestCanceled(error)) {
        sendNotification({
          type: 'error',
          message: COMMON_MESSAGES.ERROR,
        });
      }
      throw error;
    });
});

const dashboard = createSlice({
  name: 'dashboardActions',
  initialState,
  reducers: {
    updateDirectLinksStatus: (
      state: IDashboardState,
      { payload }: PayloadAction<IDirectLinksStatus>,
    ) => {
      state.directLinkStatus = payload;
      state.directLinkStatusFailed = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNominationStatus.pending, (state: IDashboardState) => {
        state.loadingDirectLinks = true;
        state.directLinkStatusFailed = true;
      })
      .addCase(
        getNominationStatus.fulfilled,
        (state: IDashboardState, { payload }: PayloadAction<IDirectLinksStatus>) => {
          state.loadingDirectLinks = false;
          state.directLinkStatus = payload;
          state.directLinkStatusFailed = false;
        },
      )
      .addCase(getNominationStatus.rejected, (state: IDashboardState) => {
        state.loadingDirectLinks = false;
        state.directLinkStatusFailed = true;
      });
  },
});

export const dashboardActions = dashboard.actions;
export default dashboard.reducer;
